import { render, staticRenderFns } from "./EditPurchasesOrderComponent.vue?vue&type=template&id=0b5e085f"
import script from "./EditPurchasesOrderComponent.vue?vue&type=script&lang=js"
export * from "./EditPurchasesOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports